import * as React from 'react';

import {
  Datagrid,
  DateField,
  List,
  TextField,
  TranslatableFields,
  useTranslate,
} from 'react-admin';
import { Theme, useMediaQuery } from '@mui/material';

import MobileGrid from './MobileGrid';

const SectionsList = () => {
  const isXsmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );
  const translate = useTranslate();

  return (
    <List bulkActionButtons={false} title={translate('pos.menu.sections')}>
      {isXsmall ? (
        <MobileGrid />
      ) : (
        <Datagrid rowClick="edit">
          <TextField
            source="nameTranslated.en"
            label={translate('resources.sections.fields.name')}
          />
          <TextField
            source="currency"
            label={translate('resources.sections.fields.currency')}
          />
          <TextField
            source="order"
            label={translate('resources.sections.fields.order')}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default SectionsList;
